'use client';

import { useEffect } from 'react';
import type { AnalyticsEventType } from '@vuganawe/types';
import { track } from '@/lib/analytics';

interface TrackEventProps {
  eventType: AnalyticsEventType;
  page: string;
  label: string;
}

/** Fires one analytics event on mount — used by server pages (program/resource views). */
export function TrackEvent({ eventType, page, label }: TrackEventProps) {
  useEffect(() => {
    track(eventType, page, label);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
